export enum OrderTransactionVenueType {
  /** Организованный рынок */
  Organized = 'Organized',
  /** Неорганизованный рынок */
  Unorganized = 'Unorganized',
}
